import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export default class DealerRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  contact() {
    throw new Error('[DealerRepository#contact] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  checkIsActiveDealer() {
    throw new Error('[DealerRepository#checkIsActiveDealer] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getTrackingPhone() {
    throw new Error('[DealerRepository#getTrackingPhone] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  setTrackingPhone() {
    throw new Error('[DealerRepository#setTrackingPhone] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  savePhoneViewHitVehicle() {
    throw new Error('[DealerRepository#savePhoneViewHitVehicle] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getDealer() {
    throw new Error('[DealerRepository#getDealer] must be implemented')
  }
}
